export default function Hero() {
  const scrollTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative min-h-[680px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Panoramic%20anime%20landscape%20illustration%20of%20a%20nostalgic%20small%20town%20at%20golden%20sunset%2C%20warm%20coral%20orange%20and%20amber%20gradient%20sky%2C%20a%20glowing%20movie%20screen%20floating%20above%20the%20rooftops%20showing%20anime%20silhouettes%2C%20drifting%20light%20particles%20and%20stars%2C%20stylized%20dreamy%20anime%20background%20art%2C%20wide%20cinematic%20composition%2C%20warm%20cozy%20atmosphere&width=1600&height=900&seq=hero-bg&orientation=landscape"
        alt="小缘动漫库 暖色系动漫小镇黄昏背景"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>

      <div className="relative z-10 w-full mx-auto max-w-5xl px-4 md:px-6 py-20 md:py-0 text-center">
        <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-white/20 text-white/90 text-xs md:text-sm px-4 py-1.5 mb-6">
          <i className="ri-heart-3-line text-primary-300"></i>
          下一部对上电波的番，由缘分决定
        </p>

        <h1 className="font-heading text-4xl md:text-6xl leading-tight text-white">
          小缘动漫库
        </h1>
        <p className="mt-4 md:mt-6 text-lg md:text-2xl text-white/95 max-w-2xl mx-auto leading-relaxed">
          打开小缘动漫库，随机推荐帮你邂逅下一部对上电波的番。
          <br className="hidden md:block" />
          缘分匹配一键生成专属看番清单，盲盒番剧带来未知惊喜。
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="#fate"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("#fate");
            }}
            className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-base font-semibold px-8 py-3.5 transition-colors cursor-pointer"
          >
            <i className="ri-magic-line"></i>
            开启今日缘分
          </a>
          <a
            href="#blindbox"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("#blindbox");
            }}
            className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm border border-white/30 text-white text-base font-semibold px-8 py-3.5 transition-colors cursor-pointer"
          >
            <i className="ri-question-mark"></i>
            开一盒盲盒
          </a>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-3 gap-3 md:gap-6 max-w-xl mx-auto">
          {[
            { num: "500+", label: "收录佳作" },
            { num: "100%", label: "随机缘分" },
            { num: "0", label: "选择困难" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-2xl bg-background-50/10 backdrop-blur-sm border border-white/15 px-3 py-4 md:py-5"
            >
              <p className="font-heading text-2xl md:text-3xl text-accent-300">{s.num}</p>
              <p className="mt-1 text-xs md:text-sm text-white/85">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        aria-label="向下滚动"
        onClick={() => scrollTo("#fate")}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 w-10 h-10 flex items-center justify-center rounded-full text-white/80 hover:text-white cursor-pointer animate-bounce"
      >
        <i className="ri-arrow-down-s-line text-2xl"></i>
      </button>
    </section>
  );
}